(async () => {
    const currencySymbol = document.body.getAttribute("currency-symbol")
    async function get_labels() {
        const countryUrl = document.body.getAttribute("country-url");
        const url = countryUrl ? `https://www.myoddballs.com${countryUrl}/pages/perfect-pair?view=labels` : "https://www.myoddballs.com/pages/perfect-pair?view=labels";

        const data12 = await fetch(url);
        const html = await data12.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        let tempLabels = []
        const inputs = doc.querySelectorAll("input.tag");
        inputs.forEach(input => {
            tempLabels.push(JSON.parse(input.value));
        });
        return tempLabels;
    }


    function addLabels() {
        const products = document.querySelectorAll('.product-card-wrapper');
        products.forEach(function(card) {
            try {
                let prodInfo = card.querySelector('.prod-info');
                let prod = JSON.parse(prodInfo.value);
                let label = generateProductLabel(prod);
                let labelLoc = card.querySelector('.liquid-product-card-label-pos');
                labelLoc.innerHTML = label;
            } catch (error) {
                console.error("Error adding label: " + error);
            }
        });


    }

    const themeVersion = document.body.dataset.themeVersion

    function generateProductLabel(data) {
        let available = data.available;
        const current_id = data.id;
        const image_url = data.featured_image;
        let prod_price = data.price;
        let comp_price = data.compare_at_price;
        const tags = data.tags;

        let label_found = false;
        let savings = 0;

        for (const label of labelList) {
            let proceed = false

            if (label.theme_version == themeVersion) {
                proceed = true;
            }

            if (label && proceed) {
                let labelMatch = label.tag_match;
                let bgColor = label.bg_color;
                let textColor = label.text_color;
                let labelText = label.text;
                let labelBorder = label.outline_color
                let countryUrl = document.body.getAttribute("country-url");
                const labelDisplay = label.show_hide_class + "whitespace-nowrap"

                if (!Array.isArray(tags)) continue;
                for (const tag of tags) {
                    if (tag === labelMatch && !label_found) {
                        if (tag === "label-sale-percent-discount") {
                            if (parseFloat(comp_price) > parseFloat(prod_price)) {
                                label_found = true;
                                savings = ((comp_price - prod_price) / comp_price * 100).toFixed(2);
                                return `<span class="${labelDisplay} top-2 right-2 rounded px-1.5 py-1 font-display text-3xs lg:!text-md  font-bold uppercase rounded-md" style="z-index:12; background-color: ${bgColor}; color:${textColor}; border: 2px solid ${labelBorder}; box-shadow: 1px 1px 1px rgb(0 0 0 / 30%);">${Math.round(savings)}${translations.collections.percent_saving}</span>`;
                            }
                        } else if (tag === "label-sale-value-discount") {
                            if (parseFloat(comp_price) > parseFloat(prod_price)) {
                                label_found = true;
                                savings = (comp_price - prod_price)/100;
                                if (savings % 1 !== 0) {
                                    savings = savings.toFixed(2);
                                }
                                return `<span class="${labelDisplay} top-2 right-2 rounded px-1.5 py-1 font-display text-3xs lg:!text-md  font-bold uppercase rounded-md" style="z-index:12; background-color: ${bgColor}; color:${textColor}; border: 2px solid ${labelBorder}; box-shadow: 1px 1px 1px rgb(0 0 0 / 30%);">Save ${currencySymbol}${savings}</span>`; //1234
                            }
                        } else {
                            label_found = true;
                            return `<span class="${labelDisplay} top-2 right-2 rounded px-1.5 py-1 font-display text-3xs lg:!text-md font-bold uppercase rounded-md" style="z-index:12; background-color: ${bgColor}; color:${textColor}; border: 2px solid ${labelBorder}; box-shadow: 1px 1px 1px rgb(0 0 0 / 30%);">${labelText}</span>`;
                        }
                    }
                }
            }
        }
        return null;
    }


    const liquidLabels = document.querySelectorAll('.liquid-product-card-label-pos');
    if (!(liquidLabels.length > 0)) return

    const labelList = await get_labels();
    addLabels();

})()